var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn softkey-btn",attrs:{"id":"KEY_B","name":"B","aria-label":"B","data-vcode":"COLOR_KEY_1"}},[_c('img',{attrs:{"src":"/images/icn-softkey-B.svg","alt":"","role":"img","aria-hidden":"true"}})])
}]

export { render, staticRenderFns }